import {
  LogIn,
  UserCircle,
  GraduationCap,
  BookOpen,
  FileText,
  Calendar,
  CalendarDays,
  ClipboardCheck,
  Award,
  Bus,
  FolderKanban,
  MessageCircle,
  Trophy,
  PenLine,
  Clock,
  Presentation,
  Library,
  ScrollText,
  Target,
  Activity,
  BookMarked,
  Truck,
  UserCheck,
  CreditCard,
  AlertTriangle,
  FileOutput,
  MessagesSquare,
  Layers,
  Users,
  UserCog,
  Calculator,
  BookCopy,
  ShieldAlert,
  Building2,
  Monitor,
  Package,
  Route,
  type LucideIcon,
} from "lucide-react";

export type SmsFeatureIcon =
  | "login"
  | "personal-details"
  | "student-details"
  | "academic-details"
  | "syllabus"
  | "timetable"
  | "calendar"
  | "examination"
  | "report-card"
  | "bus"
  | "projects"
  | "interaction-point"
  | "sports-events"
  | "assignments"
  | "extra-class"
  | "seminars"
  | "library"
  | "board-exam"
  | "competitive-exam"
  | "student-activities"
  | "academic-info"
  | "transport"
  | "attendance"
  | "fee-payment"
  | "disciplinary"
  | "transfer-certificate"
  | "message-center"
  | "subjects"
  | "exam-cell"
  | "staff-details"
  | "student-info"
  | "accountant-accounts"
  | "library-operations"
  | "students-hub"
  | "staff-hub"
  | "disciplinary-hub"
  | "hostel"
  | "software-audit"
  | "inventory"
  | "commutation";

export const smsFeatureIconMap: Record<SmsFeatureIcon, LucideIcon> = {
  login: LogIn,
  "personal-details": UserCircle,
  "student-details": GraduationCap,
  "academic-details": BookOpen,
  syllabus: FileText,
  timetable: Calendar,
  calendar: CalendarDays,
  examination: ClipboardCheck,
  "report-card": Award,
  bus: Bus,
  projects: FolderKanban,
  "interaction-point": MessageCircle,
  "sports-events": Trophy,
  assignments: PenLine,
  "extra-class": Clock,
  seminars: Presentation,
  library: Library,
  "board-exam": ScrollText,
  "competitive-exam": Target,
  "student-activities": Activity,
  "academic-info": BookMarked,
  transport: Truck,
  attendance: UserCheck,
  "fee-payment": CreditCard,
  disciplinary: AlertTriangle,
  "transfer-certificate": FileOutput,
  "message-center": MessagesSquare,
  subjects: Layers,
  "exam-cell": ClipboardCheck,
  "staff-details": UserCog,
  "student-info": Users,
  "accountant-accounts": Calculator,
  "library-operations": BookCopy,
  "students-hub": GraduationCap,
  "staff-hub": Users,
  "disciplinary-hub": ShieldAlert,
  hostel: Building2,
  "software-audit": Monitor,
  inventory: Package,
  commutation: Route,
};
